module.exports = __webpack_public_path__ + "img/pc_index_operate_r_img.38dda37b.jpg";